import Defaults from './SimulationFormDefault'
import { BannerSizeNames } from '@/models/Simulation/Constants'
import { CreativeTypes } from '@/models/Creative'

const defaults = Defaults.basicSetting

class CreativeSettingForm {
  constructor(creativeSetting = {}) {
    const { bannerSizeCode } = creativeSetting
    this.bannerSizeCode = bannerSizeCode
  }
  hasCode(code) {
    return this.bannerSizeCode.includes(code)
  }
  addCode(code) {
    if (this.hasCode(code)) return true
    this.bannerSizeCode.push(code)
  }
  removeCode(code) {
    if (!this.hasCode(code)) return true
    this.bannerSizeCode = this.bannerSizeCode.filter(e => e !== code)
  }
  setDefault() {
    this.bannerSizeCode = defaults.creativeSetting.bannerSizeCode
  }
  get isBannerEmpty() {
    return this.bannerSizeCode.length === 0
  }
  get isOnlyOneBanner() {
    return this.bannerSizeCode.length === 1
  }
  get bannerCodeNames() {
    const bannerCodeNames = this.bannerSizeCode.map(code => {
      return BannerSizeNames[code]
    })
    return bannerCodeNames
  }
}

export class SimulationFormBasic {
  static MIN_DELIVERY_DAYS = 1

  constructor(item = {}) {
    const {
      id = defaults.id,
      name = defaults.name,
      agencyId = defaults.agencyId,
      advertiserId = defaults.advertiserId,
      advertiserName = defaults.advertiserName,
      deliveryDays = defaults.deliveryDays,
      creativeSetting = defaults.creativeSetting,
      hashId = defaults.hashId,
      e2eResultHash = defaults.e2eResultHash,
      isReadOnly = defaults.isReadOnly,
      simulationPlanMenu = defaults.ownerProfileMenu,
      creativeType = defaults.ownerProfileMenu.creativeType,
    } = item
    this.id = id
    this.hashId = hashId
    this.e2eResultHash = e2eResultHash
    this.isReadOnly = isReadOnly
    this.name = name

    this.advertiserId = advertiserId
    this.advertiserName = advertiserName

    this.agencyId = agencyId

    /** UI上のみで使用する値 */
    this.selectedAdvertiser = undefined
    this.selectedAgency = undefined

    this.deliveryDays = Number(deliveryDays)
    this.creativeSetting = new CreativeSettingForm(creativeSetting)
    this.ownerProfileMenu = {
      ...simulationPlanMenu,
      id: simulationPlanMenu.originOwnerProfileMenuId,
      creativeType: creativeType,
      agencyMargin: simulationPlanMenu.agencyMargin,
    }
    this.menus = defaults.menus
    this.useAdvertiser = !!advertiserId
  }

  resetAdvertiser() {
    this.advertiserId = null
    this.advertiserName = ''
  }

  setCreativeType(creativeType) {
    if (
      creativeType === CreativeTypes.INFEED ||
      creativeType === CreativeTypes.VIDEO
    ) {
      this.creativeSetting = undefined
    } else if (creativeType === CreativeTypes.BANNER) {
      this.creativeSetting = new CreativeSettingForm()
      this.creativeSetting.setDefault()
    }
    this.ownerProfileMenu.creativeType = creativeType
  }

  setAdvertiser(advertiser) {
    this.advertiserId = advertiser.id
    this.advertiserName = advertiser.name
  }

  validation() {
    const messages = []
    if (
      !this.isReadOnly &&
      !this.useAdvertiser &&
      this.selectedAgency === undefined
    )
      messages.push('代理店を設定してください')
    if (
      !this.isReadOnly &&
      this.useAdvertiser &&
      this.selectedAdvertiser === undefined
    )
      messages.push('広告主を設定してください')
    if (this.isMenuIdEmpty) {
      messages.push('配信メニューを選択してください')
    }
    if (this.isDeliveryDaysLowerLimit) {
      messages.push('配信日数は1日以上を設定してください')
    }
    if (this.isNameEmpty) {
      messages.push('シミュレーション名を入力してください')
    }
    return messages
  }

  get isDeliveryDaysLowerLimit() {
    return this.deliveryDays < SimulationFormBasic.MIN_DELIVERY_DAYS
  }

  get isAgencyNotSetting() {
    return !this.agencyId
  }

  get isAdvertiserNotSetting() {
    return !this.advertiserId
  }

  get isNameEmpty() {
    return !this.name
  }

  get isMenuIdEmpty() {
    return (
      Object.keys(this.ownerProfileMenu).length === 0 ||
      this.ownerProfileMenu.id === undefined
    )
  }

  get isPageMovable() {
    return (
      !this.isNameEmpty && !this.isMenuIdEmpty && !this.isDeliveryDaysLowerLimit
    )
  }

  get isSimulatable() {
    return (
      !this.isMenuIdEmpty &&
      !this.isDeliveryDaysLowerLimit &&
      !(this.creativeType === 'banner' && this.creativeSetting.isBannerEmpty)
    )
  }
}
